if (!customElements.get('flavor-hotspot')) {
  class FlavorHotspot extends HTMLElement {
    connectedCallback() {
      this._panels  = [...this.querySelectorAll('[data-panel]')];
      this._buttons = [...this.querySelectorAll('[data-hotspot]')];
      this._current = 0;

      this._panels.forEach((p, i) => {
        if (i !== 0) { p.style.opacity = '0'; p.style.pointerEvents = 'none'; }
      });
      this._buttons[0]?.setAttribute('data-active', '');

      this._sidebar = this.querySelector('[data-hotspot-sidebar]');
      this._buttons.forEach((btn, i) => btn.addEventListener('click', () => this._goTo(i)));
    }

    _scrollToSidebar() {
      if (window.innerWidth >= 1024 || !this._sidebar) return;
      this._sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    _goTo(index) {
      const isNew = index !== this._current;
      if (!isNew) {
        this._scrollToSidebar();
        return;
      }
      const prev = this._panels[this._current];
      const next = this._panels[index];
      this._buttons[this._current]?.removeAttribute('data-active');
      this._buttons[this._current]?.setAttribute('aria-selected', 'false');
      this._buttons[index]?.setAttribute('data-active', '');
      this._buttons[index]?.setAttribute('aria-selected', 'true');
      this._current = index;

      prev.style.zIndex = '1';
      next.style.zIndex = '2';
      next.style.clipPath = 'inset(0 100% 0 0)';
      next.style.opacity = '1';
      next.style.pointerEvents = '';
      next.removeAttribute('aria-hidden');

      next.offsetHeight;

      next.style.transition = 'clip-path 600ms cubic-bezier(0.65, 0, 0.35, 1)';
      next.style.clipPath = 'inset(0 0% 0 0)';

      const onDone = (e) => {
        if (e.target !== next || e.propertyName !== 'clip-path') return;
        next.removeEventListener('transitionend', onDone);
        prev.style.opacity = '0';
        prev.style.pointerEvents = 'none';
        prev.setAttribute('aria-hidden', 'true');
        prev.style.zIndex = '';
        next.style.zIndex = '';
        next.style.transition = '';
        next.style.clipPath = '';
      };
      next.addEventListener('transitionend', onDone);
      this._scrollToSidebar();
    }
  }

  customElements.define('flavor-hotspot', FlavorHotspot);
}
